import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 480.000000 648.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,648.000000) scale(0.100000,-0.100000)">
        <path d="M815 4922 c4 -312 9 -569 11 -571 2 -2 5 63 6 145 1 92 3 117 5 67 5
-107 23 -109 23 -3 0 47 4 80 10 80 6 0 10 -18 10 -40 l0 -40 206 0 205 0 -3
238 -3 237 255 -2 c274 -3 464 -15 600 -38 152 -27 300 -64 396 -100 51 -19
101 -32 111 -29 13 4 14 3 5 -3 -9 -7 -2 -14 24 -26 19 -10 39 -15 44 -12 5 3
12 0 15 -6 4 -6 33 -27 64 -46 31 -20 58 -39 61 -42 3 -3 27 -23 53 -45 26
-21 61 -52 77 -69 16 -17 32 -28 36 -24 4 4 -3 15 -15 26 l-22 19 24 -2 c20
-1 23 -6 21 -33 -1 -22 5 -38 22 -54 20 -19 24 -20 18 -6 -5 13 -2 18 7 17 8
-1 109 -2 226 -1 192 1 212 3 216 19 4 16 5 16 6 0 1 -21 40 -25 59 -6 9 9 12
9 12 -2 0 -7 2 -11 5 -8 5 5 -52 118 -64 128 -3 3 -18 23 -33 45 -82 123 -117
168 -189 241 -75 77 -95 95 -198 179 -71 58 -306 185 -342 185 -5 0 -17 5 -27
10 -38 22 -301 81 -445 100 -261 33 -435 40 -975 40 l-524 -1 7 -567z m1262
102 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m426 -91 c-7 -2
-19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m367 -163 c0 -5 -7 -10 -15
-10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z m85 -81 c14 -22 -3
-18 -26 7 -23 25 -23 26 -2 15 12 -6 25 -16 28 -22z m580 -39 c3 -5 1 -10 -4
-10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z"/>
<path d="M3111 4543 c-1 -18 10 -43 20 -43 5 0 9 9 9 21 0 11 -4 18 -9 15 -5
-4 -12 0 -14 6 -4 9 -6 9 -6 1z"/>
<path d="M3610 4524 c0 -12 7 -27 15 -34 20 -17 21 9 0 36 -14 19 -14 19 -15
-2z"/>
<path d="M3090 4511 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M3160 4478 c0 -7 9 -19 20 -26 17 -10 20 -10 20 3 0 8 -9 19 -20 25
-15 8 -20 8 -20 -2z"/>
<path d="M3140 4459 c0 -9 7 -22 15 -29 8 -7 15 -19 15 -26 0 -8 4 -14 9 -14
13 0 3 31 -19 60 -15 19 -20 21 -20 9z"/>
<path d="M851 4384 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3221 4384 c-1 -12 8 -32 19 -45 l21 -24 -14 30 c-8 17 -17 37 -20
45 -4 10 -6 8 -6 -6z"/>
<path d="M3250 4381 c5 -11 15 -23 21 -27 6 -3 3 5 -6 20 -20 30 -30 35 -15 7z"/>
<path d="M3190 4375 c0 -10 22 -49 37 -63 7 -7 13 -9 13 -4 0 5 -7 15 -15 22
-8 7 -15 18 -15 26 0 7 -4 16 -10 19 -5 3 -10 3 -10 0z"/>
<path d="M3291 4194 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3316 4165 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M3381 3954 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M310 2221 l0 -1471 673 0 c878 0 1330 18 1640 63 l87 13 0 -98 0 -98
1020 0 1020 0 0 1218 0 1217 -150 153 c-83 83 -150 156 -150 160 0 5 -39 46
-86 92 l-86 83 -545 -5 -545 -6 -239 -238 -239 -239 0 -884 0 -885 -226 227
c-181 181 -231 226 -248 222 -64 -14 -329 -25 -613 -25 l-323 0 0 499 0 499
-495 487 -495 487 0 -1471z m3900 1162 c14 -10 71 -64 128 -120 56 -57 105
-103 109 -103 3 0 41 -35 85 -77 l78 -77 -2 -1116 -3 -1115 -877 -3 -878 -2 0
43 0 43 103 32 103 32 262 0 c243 0 262 1 262 18 0 9 1 82 2 162 l3 145 128
125 c75 73 125 130 122 138 -2 7 0 10 5 7 6 -3 13 1 16 9 19 49 24 -13 24
-294 l0 -310 290 0 290 0 0 1000 c0 916 -1 1003 -17 1026 -9 14 -46 53 -81 87
-36 34 -82 78 -101 98 -20 19 -57 54 -83 78 l-47 43 -338 -1 c-186 0 -364 -1
-397 -1 l-59 0 -168 -167 -169 -167 0 -753 0 -752 -21 -12 -21 -11 21 -22 c18
-19 20 -35 21 -176 1 -85 1 -159 0 -165 0 -5 -34 24 -75 65 l-75 74 0 920 0
919 203 198 202 197 465 1 c427 1 467 0 490 -16z m-340 -931 l0 -209 -55 -2
c-54 -2 -55 -2 -56 26 l0 28 -16 -32 c-16 -32 -18 -33 -85 -33 l-68 0 0 215 0
215 140 0 140 0 0 -208z"/>
<path d="M3816 2421 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M3825 2360 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M292 288 l3 -273 115 -2 c155 -3 168 0 218 48 l42 41 0 184 0 184
-44 45 -43 45 -147 0 -146 0 2 -272z m318 218 l38 -34 3 -181 3 -181 -39 -40
-40 -41 -135 3 c-100 2 -135 6 -134 16 1 6 2 121 2 255 l2 242 131 -2 130 -2
39 -35z"/>
<path d="M346 494 c-8 -21 -8 -184 1 -317 l6 -107 102 0 102 0 29 32 c29 33
29 33 32 183 l3 150 -36 38 -35 37 -99 0 c-81 0 -100 -3 -105 -16z m166 -171
c0 -43 2 -91 3 -108 3 -35 -8 -52 -33 -50 -34 2 -37 12 -34 124 l3 111 30 0
29 0 2 -77z m73 -193 c-10 -11 -21 -18 -23 -15 -6 6 31 44 37 39 2 -2 -4 -13
-14 -24z"/>
<path d="M752 516 l-42 -43 2 -229 3 -229 83 -3 c54 -2 82 1 82 8 0 6 -6 10
-12 9 -7 -1 -42 -1 -78 0 l-65 1 3 217 3 218 37 38 36 37 96 0 95 -1 39 -35
38 -36 -1 -128 c-1 -80 2 -131 9 -135 7 -4 10 38 10 130 l0 137 -42 44 -42 44
-105 0 -106 -1 -43 -43z"/>
<path d="M1134 547 c3 -10 6 -90 6 -178 0 -99 4 -159 10 -159 6 0 10 62 10
168 l0 167 55 -3 c55 -4 56 -5 77 -48 28 -60 34 -61 33 -4 l-1 49 84 3 c46 2
86 1 88 -1 2 -2 4 -80 4 -173 0 -100 4 -167 9 -164 5 4 10 85 11 181 l1 175
-106 0 c-100 0 -106 -1 -114 -22 l-8 -23 -7 23 c-7 20 -14 22 -72 22 -44 0
-64 -4 -64 -12 0 -9 -4 -8 -11 2 -9 12 -10 12 -5 -3z"/>
<path d="M1953 514 l-43 -43 0 -136 c0 -83 4 -135 10 -135 6 0 10 51 10 133
l0 133 38 36 c37 37 37 37 131 39 93 2 95 1 133 -30 l38 -32 0 -145 c0 -89 4
-144 10 -144 6 0 10 8 10 18 1 9 3 70 5 135 l4 119 -46 49 -46 49 -106 -2
-106 -1 -42 -43z"/>
<path d="M2340 370 c0 -120 4 -190 10 -190 6 0 10 67 10 180 l0 180 63 1 c34
0 72 2 85 3 22 3 22 2 22 -150 0 -84 3 -159 6 -168 5 -12 20 -16 60 -16 54 0
54 0 54 -31 0 -17 4 -28 10 -24 6 3 10 19 10 34 0 32 -18 41 -80 41 l-35 0 3
165 3 165 -111 0 -110 0 0 -190z"/>
<path d="M2708 395 c-2 -91 -1 -165 2 -165 3 0 4 -18 2 -40 -3 -25 0 -40 7
-40 8 0 11 60 11 198 l0 197 132 -3 133 -3 38 -37 38 -37 -1 -85 c-4 -181 0
-281 10 -275 14 9 13 168 -2 183 -9 9 -9 15 0 24 7 7 12 41 11 88 l-1 75 -42
37 -43 38 -146 5 -146 6 -3 -166z"/>
<path d="M3161 505 l-31 -27 0 -188 c0 -115 4 -191 10 -195 7 -4 10 61 10 189
l0 195 27 20 c14 12 24 24 21 27 -3 2 -20 -7 -37 -21z"/>
<path d="M802 479 c-39 -38 -44 -70 -40 -259 l3 -145 50 0 50 0 3 68 3 67 84
-6 85 -7 0 119 0 120 -38 37 c-36 35 -41 37 -103 37 -59 0 -68 -3 -97 -31z
m130 -123 c3 -44 2 -44 -30 -48 -18 -2 -34 -3 -35 -2 -1 2 -1 23 1 48 4 43 6
46 32 46 26 0 28 -3 32 -44z m-85 -258 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2
-13 2 -33 0 -45z"/>
<path d="M1194 497 c-2 -7 -3 -76 -2 -152 l3 -140 29 -3 c43 -5 76 6 76 26 0
15 3 14 18 -4 14 -18 28 -22 80 -22 l62 0 0 152 0 152 -50 3 -50 2 0 -106 c0
-58 -4 -105 -8 -105 -5 0 -16 19 -27 43 -61 141 -77 167 -102 167 -13 0 -26
-6 -29 -13z"/>
<path d="M2003 478 l-33 -34 0 -121 0 -120 41 -6 c47 -6 69 -1 65 16 -1 7 -1
9 1 5 3 -5 18 -8 34 -8 16 0 29 -4 29 -9 0 -5 23 -11 50 -13 l50 -3 0 127 0
127 -32 33 c-29 30 -38 33 -103 36 -68 4 -71 3 -102 -30z m138 -126 l5 -43
-35 3 c-35 3 -36 5 -39 46 l-3 43 33 -3 c31 -3 33 -6 39 -46z"/>
<path d="M2398 503 c-2 -5 -3 -80 -3 -168 l0 -160 40 -3 c60 -5 65 8 65 179 0
162 1 159 -65 159 -19 0 -35 -3 -37 -7z"/>
<path d="M2783 503 c-22 -4 -23 -5 -20 -181 l2 -176 120 -17 c68 -9 125 -13
131 -8 6 5 12 34 13 66 1 48 -2 60 -24 83 -23 24 -24 29 -12 41 23 23 35 52
38 91 3 31 -2 43 -31 73 -34 35 -35 35 -114 34 -45 -1 -91 -4 -103 -6z m147
-132 c0 -24 -5 -29 -30 -33 -28 -4 -30 -3 -30 29 0 30 3 33 30 33 26 0 30 -3
30 -29z m-75 -176 c1 -19 -2 -35 -7 -35 -4 0 -8 19 -8 42 0 49 12 44 15 -7z
m75 8 c0 -30 -3 -33 -30 -33 -27 0 -30 3 -30 33 0 31 3 34 30 34 27 0 30 -3
30 -34z"/>
<path d="M3262 503 c-13 -2 -37 -19 -53 -36 l-28 -32 -1 -176 0 -176 38 -7
c76 -12 75 -13 70 58 -3 35 -2 68 1 73 3 6 19 6 36 2 30 -8 30 -8 27 -74 l-4
-65 51 0 51 0 0 188 0 188 -29 28 c-22 21 -40 28 -82 31 -30 2 -65 1 -77 -2z
m88 -148 c0 -44 -1 -45 -33 -45 -32 0 -32 0 -29 45 4 42 6 45 33 45 28 0 29
-2 29 -45z"/>
<path d="M3478 478 c18 -18 17 -444 0 -451 -7 -3 -3 -6 8 -6 21 -1 22 1 23
220 2 219 -2 249 -32 249 -7 0 -7 -4 1 -12z"/>
<path d="M3550 251 l0 -229 38 -6 c41 -7 307 -6 333 0 14 4 17 22 18 109 1 70
-2 110 -11 124 -10 17 -10 25 0 41 15 25 16 110 1 110 -7 0 -10 -17 -7 -45 2
-25 1 -45 -2 -45 -3 0 -11 -9 -18 -20 -10 -17 -10 -23 3 -36 11 -12 15 -39 15
-120 l0 -104 -164 0 c-90 0 -170 2 -178 5 -10 4 -12 49 -10 225 2 147 -1 220
-8 220 -6 0 -10 -78 -10 -229z"/>
<path d="M3612 273 l3 -198 48 -2 47 -2 0 80 c0 43 3 79 8 79 4 0 20 -14 35
-31 21 -25 27 -41 27 -80 l0 -49 50 0 50 0 -1 74 c-1 60 -5 78 -20 92 -25 22
-24 46 1 69 16 14 20 29 19 67 -2 47 -3 48 -38 54 -20 3 -49 10 -66 14 -16 5
-52 12 -80 15 -27 4 -58 9 -68 12 -16 4 -17 -8 -15 -194z m163 116 c4 -5 4
-20 1 -32 -4 -17 -12 -22 -33 -22 -24 1 -28 6 -31 33 -3 30 -1 32 27 32 16 0
33 -5 36 -11z"/>
<path d="M3970 213 l0 -191 30 -7 c31 -7 311 -5 341 2 14 3 16 22 17 127 1 94
-2 127 -13 136 -11 9 -13 -9 -9 -119 l5 -131 -176 0 c-174 0 -181 1 -176 33 7
41 0 322 -9 331 -7 7 -10 -49 -10 -181z"/>
<path d="M4030 224 l0 -154 50 0 50 0 0 93 c0 52 3 96 6 100 4 3 19 -7 35 -23
27 -26 29 -35 29 -100 l0 -71 48 3 47 3 3 83 c3 80 2 83 -30 122 -20 24 -45
42 -63 45 -16 4 -37 7 -45 9 -8 2 -28 9 -45 16 -16 6 -42 16 -57 20 l-28 9 0
-155z"/>
<path d="M4392 133 l3 -118 155 -2 c190 -2 217 1 225 28 4 12 2 26 -5 33 -10
8 -12 6 -7 -11 3 -13 -1 -24 -9 -27 -10 -4 -279 -9 -339 -6 -6 0 -9 41 -7 110
2 75 0 110 -8 110 -7 0 -10 -37 -8 -117z"/>
<path d="M4450 149 l0 -80 48 3 47 3 0 60 0 59 -47 18 -48 18 0 -81z"/>
<path d="M2523 163 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"/>
<path d="M4621 118 l-1 -48 50 0 c42 0 50 3 50 19 0 25 -69 59 -80 40 -6 -8
-10 -5 -13 12 -2 13 -5 3 -6 -23z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
